module.exports = __webpack_public_path__ + "static/img/12043C_1_2_R_20200812_LC.10ebd22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/12043C_1_2_R_20200812_LC.png
// module id = LBpU
// module chunks = 0